export default "__VITE_ASSET__DjdLvXDj__"